export const ORDER_STATUSES = [
  { value: 'not_started', label: 'Nierozpoczęte', color: '#6c757d', bg: '#f0f1f2' },
  { value: 'in_progress', label: 'W trakcie', color: '#0066cc', bg: '#e8f0fe' },
  { value: 'completed', label: 'Zakończone', color: '#28a745', bg: '#e8f5e9' },
];

export const REJECTION_REASONS = [
  { value: 'offer_too_high', label: 'Za wysoka wartość oferty' },
  { value: 'delivery_date', label: 'Termin dostawy' },
  { value: 'no_stock', label: 'Brak towaru' },
  { value: 'other', label: 'Inne' },
];


export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('pl-PL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getRejectionLabel = (reason) => {
  const r = REJECTION_REASONS.find(rr => rr.value === reason);
  return r ? r.label : reason;
};

export const getOrderStatusInfo = (status) => {
  return ORDER_STATUSES.find(os => os.value === status) || ORDER_STATUSES[0];
};

export const getContactedChip = (value) => {
  if (value === true) return { label: 'Skontaktowano', cls: 'chip-success' };
  if (value === false) return { label: 'Nie skontaktowano', cls: 'chip-danger' };
  return { label: 'Oczekuje', cls: 'chip-neutral' };
};

export const getDealChip = (value) => {
  if (value === true) return { label: 'Umowa podpisana', cls: 'chip-success' };
  if (value === false) return { label: 'Nie podpisano', cls: 'chip-danger' };
  return { label: 'Oczekuje', cls: 'chip-neutral' };
};
